export default "__VITE_ASSET__BwuRKc3s__"